/**
 * Écran de connexion portail client (présentation uniquement).
 */
export default function PortalLoginView({
  slug,
  slugLocked = false,
  onSlugChange,
  password,
  onPasswordChange,
  loginError,
  onSubmit,
  hasSso = false,
  onSsoLogin,
}) {
  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 border border-stone-100 ring-1 ring-brand-red/10">
        <div className="flex items-center justify-center gap-3 mb-6">
          <div className="size-12 rounded-xl flex items-center justify-center overflow-hidden">
            <img
              src="/raguia.webp"
              alt="RAG IA"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-center text-stone-800 mb-2">
          Portail Client
        </h1>
        <p className="text-center text-stone-500 text-sm mb-8">
          Connectez-vous pour gérer vos documents et vos accès chatbot.
        </p>
        <form onSubmit={onSubmit} className="space-y-5">
          <div className="space-y-1">
            <label htmlFor="portal-login-slug" className="text-sm font-semibold text-stone-700">
              Identifiant client (slug)
            </label>
            <input
              id="portal-login-slug"
              className="w-full px-4 py-3 rounded-xl bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-brand-red/45 focus:border-brand-red transition-all text-stone-900"
              type="text"
              placeholder="Ex: mon-entreprise"
              value={slug}
              onChange={(e) => onSlugChange(e.target.value)}
              readOnly={slugLocked}
              required
            />
          </div>
          <div className="space-y-1">
            <label htmlFor="portal-login-password" className="text-sm font-semibold text-stone-700">
              Mot de passe
            </label>
            <input
              id="portal-login-password"
              className="w-full px-4 py-3 rounded-xl bg-stone-50 border border-stone-200 focus:outline-none focus:ring-2 focus:ring-brand-red/45 focus:border-brand-red transition-all text-stone-900"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="w-full bg-brand-red hover:bg-brand-red/90 text-white font-semibold py-3 px-4 rounded-xl transition-all shadow-md hover:shadow-lg active:scale-[0.98]"
          >
            Se connecter
          </button>
          {hasSso && (
            <>
              <div className="relative my-4">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-slate-200"></div>
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                  <span className="bg-white px-2 text-slate-400">ou</span>
                </div>
              </div>
              <button
                type="button"
                onClick={onSsoLogin}
                className="w-full bg-white border-2 border-brand-red text-brand-red font-semibold py-3 px-4 rounded-xl transition-all hover:bg-brand-red/5"
              >
                Connexion SSO Entreprise
              </button>
            </>
          )}
          {loginError && (
            <div className="p-3 bg-red-50 text-red-600 rounded-xl text-sm font-medium text-center border border-red-100">
              {loginError}
            </div>
          )}
        </form>
      </div>
    </div>
  );
}
